import styled from 'styled-components';
import { ButtonSizes, TextButton } from '../../../styles/button';

const CompanyPaginationContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 64px;
`;

interface CompanyPaginationProps {
    prevDisabled: boolean;
    nextDisabled: boolean;
    pageBack: Function;
    pageNext: Function;
}

const CompanyPagination = ({ prevDisabled, nextDisabled, pageBack, pageNext }: CompanyPaginationProps) => {
    return (
        <CompanyPaginationContainer>
            <TextButton primary size={ButtonSizes.m} disabled={prevDisabled} onClick={() => pageBack()}>
                {"< Vorherige Seite"}
            </TextButton>
            <TextButton primary size={ButtonSizes.m} disabled={nextDisabled} onClick={() => pageNext()}>
                {"Nächste Seite >"}
            </TextButton>
        </CompanyPaginationContainer>
    )
}

export default CompanyPagination